export var defaultTableSelection = {
  hoveredColumns: [],
  hoveredRows: []
};